export enum InvoiceStatus {
  Unpaid,
  Paid,
  DoesntExist,
  IsSent,
  IsNotSent
}
